import classNames from 'classnames';

import { WindChevron } from 'common/display-state/wind-chevron.js';
import { CompassDirection } from 'types/compass-direction.js';

interface IProps {
  direction: CompassDirection;
  speed?: number | string; // We treat it as a number but the API sends them all as strings. Hence the parsing below.
  className?: string;
  isHorizontal?: boolean;
  showUnits?: boolean;
  unit?: string;
}

export const DisplayWind = (props: IProps) => {
  const { direction, speed, className, isHorizontal, unit, showUnits = true } = props;

  const unitToUse = unit ? unit : 'km/h';

  // Ideally speed is a number
  let actualSpeed = speed;

  // Attempt to parse speed if it's a string
  if (typeof speed === 'string') {
    actualSpeed = parseFloat(speed);
  }

  /*
   * When the speed is 0, it means that there's no wind. Hence
   * no icon is shown and the word "Calm" replaces the direction.
   * If wind related values are `null` then the component should just render an empty space.
   * This is useful for the Forty Eight Hour Forecast component since there might be times
   * for which there's no data.
   * For more information see: https://alphero.sifterapp.com/issues/22154
   */

  // If it's still not a number then it's in the incorrect format or undefined
  const isSpeedANumber = typeof actualSpeed === 'number';

  const isCalm = actualSpeed === 0 || (!speed && direction);

  return (
    <div className={classNames(className, { 'u-flex u-flexAlignItemsCenter u-flexJustifyCenter': isHorizontal })}>
      <p className="small u-mT-0 u-mB-0" style={{ marginBottom: '4px' }}>
        {isCalm ? 'Calm' : direction}
      </p>

      <WindChevron {...props} className="SVG--md" />

      <p className="small u-mT-0 u-mB-0">
        {isSpeedANumber && (
          <>
            {speed} {showUnits && unitToUse}
          </>
        )}

        {/* When speed is not a number render out white space to keep things aligned */}
        {!isSpeedANumber && <>&nbsp;</>}
      </p>
    </div>
  );
};
